<template>
	<div class="accordion">
		<slot></slot>
	</div>
</template>

<script>
export default {
	data() {
		return {
			items: [],
		};
	},

	methods: {
		selectItem(selectedItem) {
			this.items.forEach(item => {
				if (item.isActive) {
					item.isActive = !item.isActive;
				} else {
					item.isActive = item._uid == selectedItem._uid;
				}
			});
		},
	},

	mounted() {
		this.items = this.$children;

		this.$root.$on('select-accordion', item => {
			this.selectItem(item);
		});
	},
};
</script>

<style lang="stylus" scoped></style>
